export const AUTO_SYNC_RESPONSE_STATUS = 'AUTO_SYNC_RESPONSE_STATUS';
export const CLEAR_PRICE_SYNC_LIST = 'CLEAR_PRICE_SYNC_LIST';

export const FETCH_PRICE_SYNC_LIST = 'FETCH_PRICE_SYNC_LIST';
export const FETCH_SELECTED_SYNC_ITEM = 'FETCH_SELECTED_SYNC_ITEM';
export const SET_AUTO_SYNC_PAGE_NO = 'SET_AUTO_SYNC_PAGE_NO';
export const RETAIN_AUTO_SYNC_STATE = 'RETAIN_AUTO_SYNC_STATE';
export const SET_AUTO_SYNC_STATE = 'SET_AUTO_SYNC_STATE';
export const SET_AUTO_SYNC_STATE_INTIAL ='SET_AUTO_SYNC_STATE_INTIAL';